import { isRouteErrorResponse, Link, useRouteError } from "react-router";

/** Friendly fallback for errors that escape a page (router-level errorElement). */
export function RouteError() {
  const error = useRouteError();
  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : "Something went wrong";
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 p-6 text-center">
      <h1 className="font-display text-2xl font-semibold">Something went wrong</h1>
      <p className="max-w-md text-sm text-fg-muted">{message}</p>
      <div className="flex gap-2">
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="rounded-md bg-accent px-4 py-2 text-sm font-medium text-accent-fg"
        >
          Reload
        </button>
        <Link to="/home" className="rounded-md border border-border px-4 py-2 text-sm font-medium">
          Home
        </Link>
      </div>
    </div>
  );
}
